import { Box } from '@chakra-ui/react';
import { TextArea } from '@kula-ai/components';
import { KText } from '@/ui-library/components/text';
import { SCHEDULE_AI_COPY } from '../../constants';

const COPY = SCHEDULE_AI_COPY;

export const RescheduleReasonSection = ({
  visible,
  rescheduleReason,
  onRescheduleReasonChange,
}) => {
  if (!visible) return null;
  return (
    <Box mb="20px">
      <KText
        variant="body_2"
        fontWeight="600"
        color="#413B74"
        mb="8px"
        display="block"
      >
        {COPY.rescheduleReasonLabel}
      </KText>
      <TextArea
        value={rescheduleReason}
        onChange={(e) => onRescheduleReasonChange(e.target.value)}
        placeholder={COPY.rescheduleReasonPlaceholder}
        className="min-h-[80px]"
        resize="vertical"
        style={{ fontSize: '14px' }}
        minRows={3}
        maxRows={6}
      />
    </Box>
  );
};
